define.alias("shared/components/shared/wizards/credentials/ig-business-setup", "settings/components/shared/wizards/credentials/ig-business-setup");